import { Link } from 'react-router-dom';
import PageWrapper from 'components/layout/PageWrapper';
import SubGallery from 'components/SubGallery';

const images = [
    { src: '/images/jellyPhotos/Jelly_IsoV2.png',    alt: 'Jelly isometric view' },
    { src: '/images/jellyPhotos/Jelly_TopV2.png',    alt: 'Jelly top view' },
    { src: '/images/jellyPhotos/Jelly_FrontV2.png',  alt: 'Jelly front view' },
    { src: '/images/jellyPhotos/Jelly_BottomV2.png', alt: 'Jelly bottom view' },
];

const buttonStyle = {
    margin: '10px', padding: '10px 20px', fontSize: '18px',
    backgroundColor: 'var(--color-bg-dark)', color: 'var(--color-text)',
    border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer',
};

const PastYear2021 = () => (
    <div style={{ backgroundColor: 'var(--color-bg-dark)', color: 'var(--color-text)' }}>
        <PageWrapper>
            <Link to="/fleet" className="fleet-back-link">← Back to The Fleet</Link>
            <h1 style={{ color: 'var(--color-primary)', fontSize: '60px', textAlign: 'center', fontFamily: "'NCAA Missouri Tigers', Arial" }}>Jelly</h1>
            <p style={{ fontSize: '32px', margin: '0', fontWeight: 'normal', textAlign: 'center' }}>2020-2021</p>
            <br />
            <SubGallery images={images} />
            <div style={{ textAlign: 'center', marginTop: '16px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px', marginBottom: '20px' }}>
                    <iframe
                        style={{ width: 'clamp(280px, 45vw, 560px)', height: 'clamp(158px, 25vw, 315px)', border: 'none', flexShrink: 0 }}
                        src="https://www.youtube.com/embed/6i5XHcNVHxQ"
                        title="Hull Design - Robosub 2021"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                    <iframe
                        style={{ width: 'clamp(280px, 45vw, 560px)', height: 'clamp(158px, 25vw, 315px)', border: 'none', flexShrink: 0 }}
                        src="https://www.youtube.com/embed/fuLcpXjiMRM"
                        title="Propulsion System - Robosub 2021"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
                <a href="RoboSub_2021_U-of-Missouri-Mizzou-SURF_TDR.pdf">
                    <button style={buttonStyle}>Technical Design Report</button>
                </a>
            </div>
        </PageWrapper>
    </div>
);

export default PastYear2021;
